import React, { forwardRef, PropsWithChildren } from "react";
import styles from "./box.module.css";
import cn from "classnames";

type BoxProps = {
  p?: string;
  radius?: string;
  shadow?: string;
  className?: string;
  style?: React.CSSProperties;
  direction?: "row" | "column";
  gap?: string;
  alignItems?: "center" | "flex-start" | "flex-end";
  ref?: React.RefObject<HTMLDivElement>;
  variant?: "modal" | "default";
};

export const Box = forwardRef<HTMLDivElement, PropsWithChildren<BoxProps>>(function Box(
  { children, p, radius, shadow, className, style, direction = "row", gap, alignItems, variant = "default", ...rest },
  ref
) {
  const inlineStyles: React.CSSProperties = {
    padding: p,
    borderRadius: radius,
    boxShadow: shadow,
    gap,
    alignItems,
    ...style,
  };
  return (
    <div
      ref={ref}
      style={inlineStyles}
      className={cn(styles.box, styles[direction], styles[variant], className)}
      {...rest}
    >
      {children}
    </div>
  );
});
